<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chuyển thành khách hàng</h1>
      <div class="btn-group float-right">
        <button
          type="button"
          class="btn font-medium btn-outline-secondary"
          @click="completeConvertToCustomer()"
        >
          <i class="bx bx-user-plus"></i> Hoàn tất
        </button>
        <button
          type="button"
          class="btn font-medium btn-outline-secondary"
          @click="checkCloseAdd()"
        >
          <i class="bx bx-exit"></i> Hủy bỏ
        </button>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <ValidationObserver ref="leadsAuth" class="card-body px-20 mt-2 row">
        <form class="col-md-6">
          <h1 class="form-inner-heading mb-1">Thông tin</h1>
          <ValidationProvider rules="required|minMaxName_2" vid="merchantName" name="Tên merchant">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label"
                >Tên merchant <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <input
                  v-model="dataAdd.merchantName"
                  type="text"
                  class="form-control"
                  placeholder="Tên merchant"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <div class="form">
            <ValidationProvider rules="required" vid="cityCode" name="Tỉnh/Thành phố">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Tỉnh/Thành phố <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.cityCode"
                    :options="dataProvince"
                    @select="getNameProvince($event)"
                    placeholder="Tỉnh/Thành phố"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" vid="districtCode" name="Quận/ huyện">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Quận/huyện<span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.districtCode"
                    :options="dataDistrict"
                    @select="getNameDistrict($event)"
                    placeholder="Quận/Huyện"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required|minMaxName_2" vid="address" name="Địa chỉ">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Địa chỉ<span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.address"
                    type="text"
                    class="form-control"
                    placeholder="Địa chỉ"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required|phoneLimit" vid="mobile" name="Số điện thoại">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Số điện thoại <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.mobile"
                    type="text"
                    class="form-control"
                    placeholder="Số điện thoại"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="mail_2" vid="email" name="Email">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Email</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.email"
                    type="text"
                    class="form-control"
                    placeholder="Email"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="storeSignName" name="Tên biển hiệu">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Tên biển hiệu</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.storeSignName"
                    type="text"
                    class="form-control"
                    placeholder="Tên biển hiệu"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              rules="required|minMaxName_2"
              vid="customerName"
              name="Tên người đại diện"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label"
                  >Tên người đại diện<span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.customerName"
                    type="text"
                    class="form-control"
                    placeholder="Họ tên"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <div class="form">
            <ValidationProvider rules="required" vid="customerType" name="Loại hình">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label"
                  >Loại hình<span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.customerType"
                    :options="dataCustomerType"
                    placeholder="Loại hình"
                    :class="{
                      'invalid-form': dataAdd.customerType === '' || dataAdd.customerType === null,
                    }"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" vid="mcc" name="Ngành nghề">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Ngành nghề <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.mcc"
                    :options="systemConfig.businessFields"
                    placeholder="Ngành nghề"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider v-if="dataAdd.mcc" vid="mccDetail" name="Ngành nghề chi tiết">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Ngành nghề chi tiết</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.mccDetail"
                    :options="getMccDetail(dataAdd.mcc)"
                    placeholder="Ngành nghề chi tiết"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="dataAdd.mccDetail === 'Khác'"
              vid="numberOfShop"
              name="Ngành nghề chi tiết(Ghi chú thêm)"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Ngành nghề chi tiết(Ghi chú thêm)</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.mccDetailOther"
                    placeholder="Ngành nghề chi tiết(Ghi chú thêm)"
                    type="text"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="licenseBusiness" name="Có GPDKKD không">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Có GPDKKD không</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.licenseBusiness"
                    :options="systemConfig.licenseBusiness"
                    placeholder="Có GPDKKD không"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <div class="form">
            <ValidationProvider vid="storeLocation" name="Vị trí cửa hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Vị trí cửa hàng</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.storeLocation"
                    :options="systemConfig.storeLocation"
                    placeholder="Vị trí cửa hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="averageOrder" name="Giá trị đơn hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Giá trị đơn hàng</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.averageOrder"
                    :options="systemConfig.averageOrder"
                    placeholder="Giá trị đơn hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="averageAge" name="Người mua hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Người mua hàng</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.averageAge"
                    :options="systemConfig.averageAge"
                    placeholder="Người mua hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="numberOfShop" name="Số lượng cửa hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Số lượng cửa hàng</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.extraInfo.numberOfShop"
                    type="number"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="numberOfStaff" name="Số lượng nhân viên">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Số lượng nhân viên</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.extraInfo.numberOfStaff"
                    type="number"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="cashier" name="Người thu ngân">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Người thu ngân</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.cashier"
                    :options="systemConfig.cashier"
                    placeholder="Người thu ngân"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="cashier" name="Tình trạng biển hiệu">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Tình trạng biển hiệu</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.bannerState"
                    :options="systemConfig.bannerState"
                    placeholder="Tình trạng biển hiệu"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <div class="form">
            <ValidationProvider vid="knowMPOS" name="Đã biết MPOS?">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Đã biết MPOS?</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.knowMPOS"
                    :options="systemConfig.knowMPOS"
                    placeholder="Đã biết MPOS?"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" vid="suggestServiceList" name="Dịch vụ quan tâm">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Dịch vụ quan tâm<span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataAdd.suggestServiceList"
                    :options="systemConfig.services"
                    placeholder="Dịch vụ quan tâm"
                    :class="{
                      'invalid-form':
                        dataAdd.suggestServiceList === '' || dataAdd.suggestServiceList === null,
                    }"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="lstPaymentMethodSuggest" name="PT Thanh toán quan tâm">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">PT Thanh toán quan tâm</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataAdd.extraInfo.lstPaymentMethodSuggest"
                    :options="systemConfig.paymentMethod"
                    placeholder="PT Thanh toán quan tâm"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div class="form">
            <ValidationProvider vid="ownPOS" name="Đã có POS">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Đã có POS</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.ownPOS"
                    :options="systemConfig.ownPOS"
                    placeholder="Đã có POS"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="lstPos" name="POS bên nào">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">POS bên nào</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataAdd.extraInfo.lstPos"
                    :options="systemConfig.posBank"
                    placeholder="POS bên nào"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="dataAdd.extraInfo.lstPos && dataAdd.extraInfo.lstPos.includes('OTHER')"
              vid="numberOfShop"
              name="POS bên nào(Ghi chú thêm)"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">POS bên nào(Ghi chú thêm)</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.extraInfo.posOther"
                    placeholder="POS bên nào(Ghi chú thêm)"
                    type="text"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div class="form">
            <ValidationProvider vid="hasVietQr" name="Đã có VietQR">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Đã có VietQR</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.hasVietQr"
                    :options="systemConfig.hasVietQr"
                    placeholder="Đã có VietQR"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="lstVietQrBank" name="VietQR bên nào">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">VietQR bên nào</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataAdd.extraInfo.lstVietQrBank"
                    :options="systemConfig.vietQrBank"
                    placeholder="VietQR bên nào"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="
                dataAdd.extraInfo.lstVietQrBank && dataAdd.extraInfo.lstVietQrBank.includes('OTHER')
              "
              vid="vietQrBankOther"
              name="VietQR bên nào(Ghi chú thêm)"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">VietQR bên nào(Ghi chú thêm)</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.extraInfo.vietQrBankOther"
                    placeholder="VietQR bên nào(Ghi chú thêm)"
                    type="text"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div class="form">
            <ValidationProvider vid="hasInstallment" name="Đã có Trả góp">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Đã có Trả góp</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.hasInstallment"
                    :options="systemConfig.hasInstallment"
                    placeholder="Đã có Trả góp"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="lstInstallmentBank" name="Trả góp bên nào">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Trả góp bên nào</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataAdd.extraInfo.lstInstallmentBank"
                    :options="systemConfig.installmentBank"
                    placeholder="Trả góp bên nào"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="
                dataAdd.extraInfo.lstInstallmentBank &&
                dataAdd.extraInfo.lstInstallmentBank.includes('OTHER')
              "
              vid="installmentBankOther"
              name="Trả góp bên nào(Ghi chú thêm)"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Trả góp bên nào(Ghi chú thêm)</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.extraInfo.installmentBankOther"
                    placeholder="Trả góp bên nào(Ghi chú thêm)"
                    type="text"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div class="form">
            <ValidationProvider vid="softwareUseState" name="Tình trạng dùng PM quản lý">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Tình trạng dùng PM quản lý</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataAdd.extraInfo.softwareUseState"
                    :options="systemConfig.softwareUseState"
                    placeholder="Tình trạng dùng PM quản lý"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="storeManagementSoftware" name="PM quản lý cửa hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">PM quản lý cửa hàng</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataAdd.extraInfo.storeManagementSoftware"
                    :options="systemConfig.storeManagementSoftware"
                    placeholder="PM quản lý cửa hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="
                dataAdd.extraInfo.storeManagementSoftware &&
                dataAdd.extraInfo.storeManagementSoftware.includes('OTHER')
              "
              vid="installmentBankOther"
              name="PM quản lý bên nào(Ghi chú thêm)"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">PM quản lý bên nào(Ghi chú thêm)</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataAdd.extraInfo.storeManagementSoftwareOther"
                    placeholder="PM quản lý bên nào(Ghi chú thêm)"
                    type="text"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <div class="form-group row">
            <label for class="col-sm-3 col-form-label">Ghi chú</label>
            <div class="col-sm-7">
              <input
                v-model="dataAdd.description"
                type="text"
                class="form-control"
                placeholder="Ghi chú"
              />
            </div>
          </div>
        </form>

        <form class="col-md-6">
          <div class="img-list-wrapper">
            <h1 class="form-inner-heading mb-1">Ảnh</h1>
            <div class="form-group row img-list">
              <ul>
                <li v-for="(itemImg, index) in dataUploadImage" :key="index">
                  <a href="#popup-slider" data-toggle="modal">
                    <img :src="itemImg" alt="" />
                  </a>
                </li>
                <li>
                  <div @click="showModalAddImage = true" class="add-img btn">
                    <span class="bx bx-plus text-center"></span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>

    <div v-if="showModalNoti">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalNoti = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img :src="srcImage" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="checkToActionModal(keyCheck)"
                    data-dismiss="modal"
                    v-if="keyCheck === 'accept' || keyCheck === 'back'"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalNoti = false"
                    data-dismiss="modal"
                    v-if="keyCheck === 'cancel' || keyCheck === 'back'"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <AddImages
      :limitImage="20"
      :showModalAddImage="showModalAddImage"
      :dataReceipt="dataAdd"
      :dataUploadImage="dataAdd.uploadImages"
      @submitAddImage="addCalendarImages"
      @close="closeAddImages"
      @error="showErrorAndAutoClose"
    >
    </AddImages>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { LeadsService } from '@/services/lead.service'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import merchantMx from '../../mixins/merchantMx'
  import { StaffService } from '@/services/staff.service'
  import Config from '../../thirdParty/config'

  export default {
    data() {
      return {
        dataAdd: {
          customerType: '',
          mcc: '',
          suggestServiceList: [],
          customerName: '',
          merchantName: '',
          email: '',
          mobile: '',
          address: '',
          cityCode: '',
          districtCode: '',
          extraInfo: {},
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataConfigRegion: [],
        search: {
          limit: 50,
          page: 1,
        },
        loading: false,
        pagination: {
          total: 0,
        },
        messSuccess: '',
        showModalErrCheckTrans: false,
        messErr: '',
        dataContractOrigin: [],
        dataProvince: [],
        dataDistrict: [],
        dataCustomerType: [
          { id: 'COMPANY', text: 'Doanh nghiệp' },
          { id: 'HOUSEHOLD', text: 'Hộ kinh doanh' },
          { id: 'INDIVIDUAL', text: 'Cá nhân' },
        ],
        authInfoList: this.$route.params.auth,
        showModalNoti: false,
        messNoti: '',
        srcImage: '',
        keyCheck: '',
        showModalAddImage: false,
        dataUploadImage: [],
        dataReferSource: Config.sourceCreate,
      }
    },

    mixins: [prepareQueryParamsMixin, merchantMx],

    created() {
      this.getProvince()
      this.getDistictByCode()
      this.getConfigSystem()
    },

    mounted() {
      if (this.authInfoList === 'auth') {
        this.fetchData(this.$route.params.leadId)
      } else {
        this.dataAdd = this.dataLead
        if (this.dataAdd.cityCode && this.dataAdd.cityCode !== '') {
          this.getDistictByCode()
        }
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        dataLead: 'leads/getDataLead',
      }),
    },

    methods: {
      async checkCloseAdd() {
        this.keyCheck = 'back'
        this.showErr('Bạn có chắc chắn muốn huỷ bỏ thao tác không ?')
      },

      async closeAdd() {
        this.$router.push('/leads')
      },

      async fetchData(leadId) {
        try {
          const response = await LeadsService.detailLead({
            leadId: leadId,
          })
          if (response.code === 1000 || response.success) {
            this.dataAdd = response.data
            this.dataUploadImage = this.dataAdd.uploadImages
            this.checkSuggestService()
            if (this.dataAdd.cityCode && this.dataAdd.cityCode !== '') {
              this.getDistictByCode()
            }
          }
        } catch (error) {
          console.log(error)
        }
      },

      async addLead(isAllow) {
        try {
          if (isAllow) this.dataAdd.allowSave = true
          else delete this.dataAdd.allowSave

          this.checkToDelete()

          const isSuccess = await this.$refs.leadsAuth.validate()
          if (!isSuccess) {
            this.keyCheck = 'cancel'
            this.showErr('Vui lòng điền đúng thông tin !')
            return
          }

          this.checkSuggestService()

          const response = await LeadsService.registerLead(this.dataAdd)
          if (response.code === 1000) {
            this.showModalNoti = true
            this.messNoti = 'Thêm Lead thành công !'
            this.keyCheck = 'accept'
            this.srcImage = require('@/assets/img/noti-success2.svg')
          } else if (response.code === 1025 || response.code === 1039) {
            this.keyCheck = 'addLead'
            this.showErr(response.message)
          } else {
            this.keyCheck = 'cancel'
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        }
      },

      async completeConvertToCustomer() {
        try {
          const isSuccess = await this.$refs.leadsAuth.validate()
          if (!isSuccess) {
            this.keyCheck = 'cancel'
            this.showErr('Vui lòng điền đúng thông tin !')
            return
          }

          // this.checkToDelete()

          this.checkSuggestService()

          const response = await LeadsService.completeConvertToCustomer(this.dataAdd)
          if (response.code === 1000) {
            this.showModalNoti = true
            this.messNoti = response.message
            this.keyCheck = 'accept'
            this.srcImage = require('@/assets/img/noti-success2.svg')
          } else {
            this.keyCheck = 'cancel'
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        }
      },

      checkToDelete() {
        if (this.dataAdd.districtCode === '0') {
          delete this.dataAdd.districtCode
          delete this.dataAdd.district
        }

        if (this.dataAdd.suggestServiceList && this.dataAdd.suggestServiceList.length === 0) {
          delete this.dataAdd.suggestServiceList
        }
      },

      checkSuggestService() {
        const serviceList = []
        if (
          this.dataAdd.suggestServiceList &&
          this.dataAdd.suggestServiceList.length > 0 &&
          this.dataAdd.suggestServiceList !== null
        ) {
          this.dataAdd.suggestServiceList.map(e => {
            if (e.serviceType && e.serviceType !== null) serviceList.push(e.serviceType)
            // else delete this.dataAdd.suggestServiceList
          })
        }
        this.dataAdd.suggestServiceList =
          serviceList.length !== 0 ? serviceList : this.dataAdd.suggestServiceList
      },

      async getProvince() {
        try {
          const data = await StaffService.getAllCity({})
          if (data.data.length > 0) {
            data.data.forEach(e => {
              this.dataProvince.push({
                id: e.code,
                text: e.name,
              })
            })
          }
        } catch (error) {
          console.log(error)
        }
      },

      async getDistictByCode() {
        try {
          this.dataDistrict = []
          const data = await StaffService.getDistictByCode({})
          if (data.data.length > 0) {
            const dataDistrict = []
            data.data.map(e => {
              dataDistrict.push({ id: e.code, text: e.name })
            })
            this.dataDistrict = dataDistrict
          }
        } catch (error) {}
      },

      getNameProvince(item) {
        this.dataAdd.city = item.text
      },
      getNameDistrict(item) {
        this.dataAdd.district = item.text
      },

      showErr(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-unsuccess2.svg')
      },
      checkToActionModal(keyCheck) {
        if (keyCheck === 'accept' || keyCheck === 'back') {
          this.showModalNoti = false
          this.closeAdd()
        }
        if (keyCheck === 'addLead') {
          this.showModalNoti = false
          this.addLead(true)
        }
      },

      checkServiceList() {
        let check = false
        if (
          this.dataAdd.suggestServiceList.length === 0 ||
          this.dataAdd.suggestServiceList === null
        ) {
          check = true
        }
        if (this.dataAdd.suggestServiceList !== null) {
          this.dataAdd.suggestServiceList.map(e => {
            if (e.serviceType === null) {
              check = true
            }
          })
        }
        return check
      },

      addCalendarImages(dataImage) {
        this.dataAdd.uploadImages = this.dataUploadImage = dataImage
      },

      closeAddImages() {
        this.showModalAddImage = false
        this.dataAdd.uploadImages = this.dataUploadImage
      },

      showErrorAndAutoClose(message) {
        this.keyCheck = 'cancel'
        this.showErr(message)
        setTimeout(() => {
          this.showModalNoti = true
        }, 1200)
      },
    },
  }
</script>

<style scoped>
  .placeholder {
    background: #f0f0f0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-family: Helvetica;
  }

  .placeholder:hover {
    background: #e0e0e0;
  }
  .invalid-form {
    border: solid 0.5px #dc3545 !important;
    border-radius: 5px;
  }
  .form {
    border-bottom: 1px solid #bbbbbb;
    margin-bottom: 1rem;
  }
</style>
